import { render, staticRenderFns } from "./Current.vue?vue&type=template&id=2c69a36c"
import script from "./Current.vue?vue&type=script&lang=js"
export * from "./Current.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports